import { onMounted, onUnmounted, ref } from 'vue';
import { useStore } from '@nuxtjs/composition-api';
import { breakpointsTailwind } from '@vueuse/core';

type Breakpoint = keyof typeof breakpointsTailwind;

// Замена useBreakpoint из frontkit. Там значение берётся из ширины окна в
// onBeforeMount, то есть до гидрации. Сервер рендерит по типу устройства из UA,
// и если ширина окна с ним не совпадает (планшеты, узкое окно на десктопе),
// клиентская разметка расходится с серверной. В проде Vue 2 при этом не
// пересоздаёт DOM, а цепляет компоненты к чужим узлам, и <swiper-container>
// не инициализируются. Поэтому значение с сервера держим до монтирования.
// TODO: удалить и переиспользовать useBreakpoint из frontkit после фикса
export default function useBreakpoint(screen: Breakpoint) {
  const store = useStore();
  const isBiggerThanBreakpoint = ref<boolean>(store.getters['device/getIsPc']);

  const onResize = () => {
    isBiggerThanBreakpoint.value =
      window.innerWidth >= breakpointsTailwind[screen];
  };

  onMounted(() => {
    onResize();
    window.addEventListener('resize', onResize, { passive: true });
  });

  onUnmounted(() => {
    window.removeEventListener('resize', onResize);
  });

  return { isBiggerThanBreakpoint };
}
